import { render } from "./TableauBord.vue?vue&type=template&id=12a43110&ts=true"
import script from "./TableauBord.vue?vue&type=script&lang=ts"
export * from "./TableauBord.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__